"use client";
import { useTranslator } from "./context.js";
import { jsx } from "react/jsx-runtime";
//#region src/i18n/text.tsx
/** Renders translated compiler text through a native React span. */
function Text({ children, token, ...props }) {
	const t = useTranslator();
	const fallback = typeof children === "string" || typeof children === "number" ? String(children) : void 0;
	return /* @__PURE__ */ jsx("span", {
		...props,
		children: token ? t({
			key: token,
			text: fallback ?? token
		}) : children
	});
}
//#endregion
export { Text };

//# sourceMappingURL=text.js.map